module.exports = __webpack_public_path__ + "static/ru-logo100-web-white-34cb3f343232d890586aa0b3e75e2796.svg";